import { render, staticRenderFns } from "./TagsArea.vue?vue&type=template&id=1381c172&scoped=true&"
import script from "./TagsArea.vue?vue&type=script&lang=js&"
export * from "./TagsArea.vue?vue&type=script&lang=js&"
import style0 from "./TagsArea.vue?vue&type=style&index=0&id=1381c172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1381c172",
  null
  
)

export default component.exports